<div class="pl-bar-chart flex flex-col items-center gap-4">
  <h3 *ngIf="title" class="text-center">{{ title }}</h3>

  <div #chartContainer></div>
</div>
